export enum UserRole {
  Manager = 'Manager',
  Reviewer = 'Reviewer',
  Previewer = 'Previewer',
}

export interface User {
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  client_user_id: string;
  manager: string;
  roles: string[];
  data: string[];
  created_at: string;
  updated_at: string;
  last_active: string;
  has_manager_role: boolean;
}

export type UserAdmin = User & {
  status?: string;
};
